import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import Lists from "./pages/Lists";
import List from "./pages/List";
import CreateList from "./pages/CreateList";
import RankingSubmitted from "./pages/RankingSubmitted";
import ListClosed from "./pages/ListClosed";
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Outlet,
} from "react-router-dom";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Outlet />}>
      <Route index element={<Lists />} />
      <Route path="create-new-ranking" element={<CreateList />} />
      <Route path=":created" element={<Outlet />}>
        <Route index element={<List />} />
        <Route path="ranking-submitted" element={<RankingSubmitted />} />
        <Route path="list-closed" element={<ListClosed />} />
      </Route>
    </Route>
  )
);

function Main() {
  return <RouterProvider router={router} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);
